import { Stack } from '@mui/material';
import { formatDuration } from 'date-fns';

import { PlanungsinformationFromThemaRouter, ThemaFromThemaRouter } from '../../../dtos';
import { isTermingruppe } from '../../../utils';
import { LabelValue } from '../LabelValue';
import { content } from './TerminPlanungsinformationenCard.content';
import { getQuartalTableRows } from './TerminPlanungsinformationenCard.utils';

type FirstSectionProps = {
  readonly planungsinformation: PlanungsinformationFromThemaRouter;
  readonly planungsformat: ThemaFromThemaRouter['planungsformat'];
  readonly isPlanung: boolean;
};

export const FirstSection = ({ planungsinformation, planungsformat, isPlanung }: FirstSectionProps) => {
  const { dauer } = planungsinformation;

  return (
    <Stack spacing={1.5}>
      {!isPlanung && !isTermingruppe(planungsformat) && (
        <LabelValue
          key={content.fields.dauer}
          label={content.fields.dauer}
          value={dauer ? formatDuration(dauer) : undefined}
        />
      )}
      {getQuartalTableRows(
        planungsinformation,
        isTermingruppe(planungsformat) ? content.fields.durchgaenge : content.fields.veranstaltungen,
      ).map(([label, value]) => (
        <LabelValue key={label} label={label} value={value} />
      ))}
    </Stack>
  );
};
